var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-tiktok" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.tiktok.privacy")) + " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c(
            "div",
            { staticClass: "content-detail" },
            [
              _c("SelectComponent", {
                attrs: {
                  valueSelect:
                    _vm.draftInstance.form.networks.tiktok.visibility,
                  changeValueSelect: _vm.changeVisibilityPost,
                  data: {
                    PUBLIC_TO_EVERYONE: _vm.$t(
                      "dash.post-creator.form.tiktok.visibility-public"
                    ),
                    MUTUAL_FOLLOW_FRIENDS: _vm.$t(
                      "dash.post-creator.form.tiktok.visibility-friends"
                    ),
                    SELF_ONLY: _vm.$t(
                      "dash.post-creator.form.tiktok.visibility-me"
                    ),
                  },
                  positionAuto: false,
                  positionX: "left",
                },
              }),
              _vm.hasVideo && _vm.nativeMode
                ? _c("div", { staticClass: "list-simple-btn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "type-btn-simple",
                        on: {
                          click: function ($event) {
                            return _vm.addMode("addTiktokMusicMode")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa-solid fa-music" }),
                        _c("p", [
                          _vm._v("Musique "),
                          _c("span", { staticClass: "pink" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.draftInstance.form.networks.tiktok.music
                                    ? "1"
                                    : "0"
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _vm._v(
                    "\n                 " +
                      _vm._s(
                        _vm.$t("dash.post-creator.form.tiktok.disable-comments")
                      ) +
                      "\n                 "
                  ),
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.draftInstance.form.networks.tiktok.commentDisable,
                      onChange: (v) =>
                        (_vm.draftInstance.form.networks.tiktok.commentDisable =
                          v),
                      id: "switch-settings-advanced-tiktok-1",
                    },
                  }),
                ],
                1
              ),
              _vm.hasVideo
                ? _c(
                    "div",
                    { staticClass: "type-switch" },
                    [
                      _vm._v(
                        "\n                 " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.tiktok.allow-duo")
                          ) +
                          "\n                 "
                      ),
                      _c("ComponentSwitch", {
                        attrs: {
                          value:
                            _vm.draftInstance.form.networks.tiktok
                              .useVideoForDuo,
                          onChange: (v) => {
                            _vm.draftInstance.form.networks.tiktok.useVideoForDuo =
                              v
                          },
                          id: "switch-settings-advanced-tiktok-2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasVideo
                ? _c(
                    "div",
                    { staticClass: "type-switch" },
                    [
                      _vm._v(
                        "\n                 " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.tiktok.allow-stitch")
                          ) +
                          "\n                 "
                      ),
                      _c("ComponentSwitch", {
                        attrs: {
                          value:
                            _vm.draftInstance.form.networks.tiktok
                              .useVideoForOtherVideo,
                          onChange: (v) => {
                            _vm.draftInstance.form.networks.tiktok.useVideoForOtherVideo =
                              v
                          },
                          id: "switch-settings-advanced-tiktok-3",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasPhotos
                ? _c(
                    "div",
                    { staticClass: "type-switch" },
                    [
                      _vm._v(
                        "\n                 " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.tiktok.auto-music")
                          ) +
                          "\n                 "
                      ),
                      _c("ComponentSwitch", {
                        attrs: {
                          value:
                            _vm.draftInstance.form.networks.tiktok.autoAddMusic,
                          onChange: (v) => {
                            _vm.draftInstance.form.networks.tiktok.autoAddMusic =
                              v
                          },
                          id: "switch-settings-advanced-tiktok-4",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _vm._v(
                    "\n                     " +
                      _vm._s(
                        _vm.$t("dash.post-creator.form.tiktok.brand-content")
                      ) +
                      "\n                 "
                  ),
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.draftInstance.form.networks.tiktok
                          .brandContentToggle,
                      onChange: (v) => {
                        _vm.draftInstance.form.networks.tiktok.brandContentToggle =
                          v
                      },
                      id: "switch-settings-advanced-tiktok-5",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _vm._v(
                    "\n                     " +
                      _vm._s(
                        _vm.$t("dash.post-creator.form.tiktok.brand-organic")
                      ) +
                      "\n                 "
                  ),
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.draftInstance.form.networks.tiktok
                          .brandOrganicToggle,
                      onChange: (v) => {
                        _vm.draftInstance.form.networks.tiktok.brandOrganicToggle =
                          v
                      },
                      id: "switch-settings-advanced-tiktok-6",
                    },
                  }),
                ],
                1
              ),
              _vm.hasVideo
                ? _c(
                    "div",
                    { staticClass: "type-switch" },
                    [
                      _vm._v(
                        "\n                     " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.tiktok.ai-generated")
                          ) +
                          "\n                 "
                      ),
                      _c("ComponentSwitch", {
                        attrs: {
                          value: _vm.draftInstance.form.networks.tiktok.isAigc,
                          onChange: (v) => {
                            _vm.draftInstance.form.networks.tiktok.isAigc = v
                          },
                          id: "switch-settings-advanced-tiktok-7",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }